import { useQuery } from '@tanstack/react-query';
import { supabasePublic } from '@/integrations/supabase/publicClient';
import { formatDateLocal } from '@/lib/timeFormatUtils';
import type { TimeBlockRow } from '../../../supabase/functions/_shared/timeBlocks';

/** Heures fermées en ligne (lecture publique, dates à venir). Vide = aucun effet. */
export function useTimeSlotBlocksQuery(establishmentId: string | null | undefined) {
  return useQuery({
    queryKey: ['time-slot-blocks-public', establishmentId],
    queryFn: async (): Promise<TimeBlockRow[]> => {
      const { data, error } = await supabasePublic
        .from('time_slot_blocks')
        .select('block_date, start_time, end_time, blocks_overlap')
        .eq('establishment_id', establishmentId as string)
        .gte('block_date', formatDateLocal(new Date(Date.now() - 86400000)));
      if (error) throw error;
      return data || [];
    },
    enabled: Boolean(establishmentId),
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
